// ─────────────────────────────────────────────
// Event names — single source of truth
// Shared between client and server analytics
// ─────────────────────────────────────────────
export const AnalyticsEvent = {
  // Onboarding
  ONBOARDING_STARTED: 'onboarding_started',
  ONBOARDING_COMPLETED: 'onboarding_completed',

  // Welcome / activation funnel (Ship 1)
  WELCOME_PAGE_VIEWED: 'welcome_page_viewed',
  WELCOME_TASK_FIRST_VIEW: 'welcome_task_first_view',
  WELCOME_SUGGESTION_KEPT: 'welcome_suggestion_kept',
  WELCOME_SUGGESTION_REMOVED: 'welcome_suggestion_removed',
  WELCOME_CTA_CLICKED: 'welcome_cta_clicked',
  WELCOME_EXITED: 'welcome_exited',
  WELCOME_GENERATION_STARTED: 'welcome_generation_started',
  WELCOME_GENERATION_ITEM_DONE: 'welcome_generation_item_done',
  WELCOME_GENERATION_ITEM_FAILED: 'welcome_generation_item_failed',
  WELCOME_GENERATION_COMPLETED: 'welcome_generation_completed',
  // Activation gate — emit on every task complete, regardless of source.
  // Used in baseline + post-Ship-1 lift measurement.
  MAINTENANCE_TASK_COMPLETED: 'maintenance_task_completed',

  // Core CRUD (tracked server-side, listed here for reference)
  ITEM_CREATED: 'item_created',
  MAINTENANCE_TASK_CREATED: 'maintenance_task_created',
  UTILITY_CREATED: 'utility_created',
  BILL_CREATED: 'bill_created',
  PART_CREATED: 'part_created',
  DOCUMENT_ADDED: 'document_added',

  // AI features
  DETECTION_STARTED: 'detection_started',
  DETECTION_COMPLETED: 'detection_completed',
  INVOICE_SCANNED: 'invoice_scanned',
  SCAN_INVOICE_CLICKED: 'scan_invoice_clicked',
  CHAT_MESSAGE_SENT: 'chat_message_sent',
  CLARK_OPENED_FROM: 'clark_opened_from',

  // Dashboard triage
  DASHBOARD_HERO_RENDERED: 'dashboard_hero_rendered',
  DASHBOARD_HERO_ACTION: 'dashboard_hero_action',

  // Clark starters (dashboard NudgesPanel + chat empty state)
  // Properties: { starter_key, category, position, source: 'dashboard'|'chat' }
  CLARK_STARTER_IMPRESSION: 'clark_starter_impression',
  CLARK_STARTER_CLICKED: 'clark_starter_clicked',

  // Monetization
  ENTITY_LIMIT_REACHED: 'entity_limit_reached',
  UPGRADE_PROMPT_SHOWN: 'upgrade_prompt_shown',
  SUBSCRIPTION_UPGRADED: 'subscription_upgraded',
} as const

export type AnalyticsEventName = (typeof AnalyticsEvent)[keyof typeof AnalyticsEvent]
